import React from 'react'
import './quote.css'
const data = require('./bible.json')

class Quotes extends React.Component {
    constructor(){
       super()
       this.state = {
           quote: "",
           author: "",
           verse: "",
           chapter: "",
           clicked: true,
           show: false,

       } 
       this.ChangeState = this.ChangeState.bind(this)
       this.showModal = this.showModal.bind(this);
       this.hideModal = this.hideModal.bind(this);

    }

    ChangeState() {
       this.setState(prevState => {
        console.log("clicked")
        return {
            clicked: !prevState.clicked
        }
    })
   }

   showModal = () => {
    this.setState({ show: true });
  };

   hideModal = () => {
    this.setState({ show: false });
  };
   

    componentDidMount(){
        this.fetchQuote();
        this.fetchVerse();
    }
   
    fetchQuote = () => {
        fetch('https://type.fit/api/quotes')
        .then(Response => Response.json())
        .then(Response => {
            const length = Response.length
            var index = Math.floor((Math.random() * length) + 1)
            var quote = Response[index].text
            var author = Response[index].author
            console.log(quote + ' - ' + author)

            this.setState({quote: quote,
                           author: author})
        })
    }
    
    fetchVerse = () => {
        const length = data.length
            var index = Math.floor((Math.random() * length) + 1)
            var chapter = data[index].Verse + ' KJV'
            var verse = data[index].KJV.replace("<i>", '').replace("</i>", '')
            var n = 5;
            while (n > 0) {
                    verse = verse.replace("<i>", '').replace("</i>", '')
                    console.log(verse)
                    --n;
             }
            console.log(verse + ' - ' + chapter)
            this.setState({verse: verse,
                           chapter: chapter})
    }


    render() {
        const showHideClassName = this.state.show ? "modal display-block" : "modal display-none";
        const Chapter = this.state.chapter
        const Verse = this.state.verse
        if (this.state.show != true){
            return(
                <div className="quote" onClick={this.fetchVerse}>
                    <h1 className="heading">{Verse} </h1>
                    <h1 className="author">{Chapter} </h1>
                    <h2 onClick={this.showModal}>CLICK ME [Bible Verses]</h2>
                </div>
            )
            } else {
                  return(
                      <section>
                    <div className={showHideClassName}>
                      <span className='X'draggable='true' onClick={this.hideModal}>
                      &times;
                      </span>

                    <h1 className="VerseModal">Click the Image to Read More</h1>
                    <a href="https://www.kingjamesbibleonline.org/" target="_blank">
                   <img alt="KJV Bible" src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fldsvoice.files.wordpress.com%2F2011%2F09%2Fholy-bible.jpg&f=1&nofb=1" width="150" height="204">
                       </img>
                    </a>
                  </div>
                  </section>
        //} else {
          //  return(
            //    <div className="quote" onClick={this.fetchQuote}>
              //      <h1 className="heading">{this.state.quote} </h1>
               //     <h1 className="author">{this.state.author} </h1>
               //     <h2 onClick={this.ChangeState}>CLICK ME [Famous Quotes]</h2>
               // </div>
           // ) 
                  )}
    }
}

export default Quotes